import Box from '@mui/material/Box';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useMediaQuery, useTheme } from '@mui/material';
import type { JSX } from 'react';

import { AppDialog } from '../AppDialog';
import { useAuthStore, type AuthModalTab } from '../../store/useAuthStore';
import { GoogleSignInButton } from './GoogleSignInButton';
import { GuestTab } from './GuestTab';
import { LogInTab } from './LogInTab';
import { SignUpTab } from './SignUpTab';

export function AuthModal(): JSX.Element {
  const open = useAuthStore((s) => s.authModalOpen);
  const tab = useAuthStore((s) => s.authModalTab);
  const close = useAuthStore((s) => s.closeAuthModal);
  const switchTab = useAuthStore((s) => s.switchTab);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AppDialog id="auth-modal" open={open} onClose={close} fullScreen={fullScreen} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pb: 0 }}>How would you like to start?</DialogTitle>
      <Tabs
        value={tab}
        onChange={(_e, v: AuthModalTab) => switchTab(v)}
        variant="fullWidth"
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab value="login" label="Log In" />
        <Tab value="signup" label="Sign Up" />
      </Tabs>
      <DialogContent>
        {tab === 'login' && (
          <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <LogInTab />
            <Divider>or</Divider>
            <GuestTab />
            <GoogleSignInButton />
          </Box>
        )}
        {tab === 'signup' && (
          <Box sx={{ pt: 2 }}>
            <SignUpTab />
          </Box>
        )}
      </DialogContent>
    </AppDialog>
  );
}
